import React from "react";
import { Box, Typography, TextField } from "@material-ui/core";
import Button from "storybookComponents/Button";
import Modal from "components/Modal";
import "./index.css";
import { withStyles } from "@material-ui/core";
const styles = () => ({
  confirmHeader: {
    // width: 460,
    fontSize: 16,
    color: "333333",
    // paddingBottom: 24,
  },
  cancelButton: {
    height: 40,
    //width: 102,
    marginRight: 12,
  },
  disapproveButton: {
    fontWeight: "100 !important",
    height: 40,
    //width: 165
  },
  feedbackStyle: {
    fontSize: 12,
    color: "gray",
  },
});
export default withStyles(styles)(
  ({
    disapprove,
    title,
    eventName,
    open,
    toggler,
    reason,
    cancelText,
    actionText,
    classes,
    action,
    pre_message,
    post_message,
    message,
    customAction,
    customVariant,
  }) => {
    const [feedback, setFeedback] = React.useState(null);
    const handleChange = (e) => {
      setFeedback(e.target.value);
    };
    React.useEffect(() => {
      setFeedback(null);
    }, [open]);
    return (
      <Modal
        open={open}
        maxWidth="sm"
        title={title}
        handleClose={toggler}
        actionChildren={
          <>
            <Button
              className={classes.cancelButton}
              color="darkBlack"
              variant="tertiary"
              size="md"
              state={customAction && !feedback && reason ? "inactive" : "active"}
              onClick={customAction ? customAction.bind(this, feedback) : toggler}
            >
              {cancelText}
            </Button>
            <Button
              className={classes.disapproveButton}
              state={!reason ? "active" : feedback ? "active" : "inactive"}
              color="darkBlack"
              type="submit"
              variant={customVariant ? { customVariant } : "secondary"}
              negative={disapprove}
              size="md"
              onClick={() => action(feedback)}
            >
              <strong>{actionText}</strong>
            </Button>
          </>
        }
      >
        <div id="confirm" className={classes.confirmBody}>
          <div className={classes.confirmHeader}>
            {message ? (
              typeof message === "function" ? (
                message()
              ) : (
                message
              )
            ) : (
              <>
                {pre_message} {eventName ? <b>{eventName}</b> : ""} {post_message}
              </>
            )}
          </div>
          {reason ? (
            <div>
              <div className={classes.feedbackStyle}>
                Feedback<sup>*</sup>
              </div>
              <textarea onChange={handleChange}></textarea>
            </div>
          ) : null}
        </div>
      </Modal>
    );
  }
);